export enum Cookie {
  SPLIT_USER_ID = 'split_user_id',
  SPLIT_IS_VIP = 'split_is_vip',
}
